import axios from "../../lib/axiosInstance";

export function me(payload) {
  return axios.get("users/me", payload).then((res) => res.data);
}

export function fetchNearbyFreelancers(payload) {
  const queryParams = new URLSearchParams();

  // Include only non-empty filters in the query parameters
  if (payload.latitude) {
    queryParams.append("latitude", payload.latitude);
  }
  if (payload.longitude) {
    queryParams.append("longitude", payload.longitude);
  }
  if (payload.radius) {
    queryParams.append("radius", payload.radius);
  }
  if (payload?.limit) {
    queryParams.append("limit", payload.limit);
  }
  if (payload?.page) {
    queryParams.append("page", payload.page);
  }
  if (payload?.search) {
    queryParams.append("search", payload.search);
  }
  if (payload.workOrderId) {
    queryParams.append("workOrderId", payload.workOrderId);
  }
  if (payload.talentPoolId) {
    queryParams.append("talentPoolId", payload.talentPoolId);
  }
  if (payload?.sortBy) {
    queryParams.append("sortBy", payload.sortBy);
  }
  if (payload?.sortOrder) {
    queryParams.append("sortOrder", payload.sortOrder);
  }
  if (payload?.mode) {
    queryParams.append("mode", payload.mode);
  }
  if (payload?.filterByRequiredSkills) {
    queryParams.append("filterByRequiredSkills", payload.filterByRequiredSkills);
  }
  if (payload?.filterByRequiredTools) {
    queryParams.append("filterByRequiredTools", payload.filterByRequiredTools);
  }

  return axios.get("users/nearby", { params: queryParams }).then((res) => res.data);
}

export function fetchUserDetails(id, direct = false) {
  return axios.get(`users/${id}${direct ? "?direct=true" : ""}`).then((res) => res.data);
}
export function fetchJobsCompleted(
  userId,
  page = undefined,
  limit = undefined,
  search = undefined,
) {
  const params = {};
  if (page) params.page = page;
  if (limit) params.limit = limit;
  if (search) params.search = search;

  return axios.get(`users/${userId}/jobsCompleted`, { params }).then((res) => res.data);
}

export function fetchJobsCompletedCount(userId) {
  return axios
    .get(`users/${userId}/jobsCompleted`, { params: { countOnly: true } })
    .then((res) => res.data);
}

export function fetchNearbyRateComparison(payload) {
  const queryParams = new URLSearchParams();

  if (payload.distance) queryParams.append("distance", String(payload.distance));
  if (payload.paymentType) queryParams.append("paymentType", payload.paymentType);
  if (payload.latitude) queryParams.append("latitude", String(payload.latitude));
  if (payload.longitude) queryParams.append("longitude", String(payload.longitude));
  if (payload.currency) queryParams.append("currency", payload.currency);

  return axios.get(`users/nearby/rateComparison`, { params: queryParams }).then((res) => res.data);
}
export function fetchWorkedWithEngineers(companyId, status, customerStatus, email) {
  return axios
    .get(`users/workedWith`, { params: { companyId, status, customerStatus, email } })
    .then((res) => res.data);
}

export function fetchUserQualifications(id) {
  return axios.get(`users/qualifications/${id}`).then((res) => res.data);
}
export function fetchUserSkills(id) {
  return axios.get(`users/skills/${id}`).then((res) => res.data);
}

export function addUserQualifications(payload, targetUserId) {
  return axios
    .post("users/qualifications", payload, { params: targetUserId ? { targetUserId } : undefined })
    .then((res) => res.data);
}
export function updateUserQualifications({ id, data, targetUserId }) {
  return axios
    .patch(`users/qualifications/${id}`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      params: targetUserId ? { targetUserId } : undefined,
    })
    .then((res) => res.data);
}
export function fetchUserQualificationsByType(userId, qualificationTypeId) {
  return axios.get(`users/qualifications/${userId}/${qualificationTypeId}`).then((res) => res.data);
}
export function fetchUserAllQualifications(userId) {
  return axios
    .get(`users/qualifications`, { params: userId ? { userId } : undefined })
    .then((res) => res.data);
}

export function fetchUserBackgroundVerificationDocs(id) {
  return axios.get(`users/backgroundVerification/${id}`).then((res) => res.data);
}

export function addSkillsToUser(payload) {
  const { id, ...rest } = payload;
  return axios.post(`users/skills/${payload?.id}`, rest).then((res) => res.data);
}
export function deleteUser(id, reason, otp) {
  return axios.delete(`users/${id}`, { data: { reason, otp } }).then((res) => res.data);
}
export function deleteUserSkill(id, targetUserId) {
  return axios
    .delete(`users/skills/${id}`, { params: targetUserId ? { targetUserId } : undefined })
    .then((res) => res.data);
}
export function deleteUserQualification(id, targetUserId) {
  return axios
    .delete(`users/qualifications/${id}`, { params: targetUserId ? { targetUserId } : undefined })
    .then((res) => res.data);
}

export function createOrUpdateUserAddress(payload) {
  return axios.patch("users/address", payload).then((res) => res.data);
}
export function updateUserDetails(payload) {
  return axios.patch("users", payload).then((res) => res.data);
}
export function createOrUpdateUserBillingRates(payload) {
  return axios.patch("users/billingRates", payload).then((res) => res.data);
}

export function fetchUserJobActivity(userId) {
  return axios.get(`users/jobActivity?userId=${userId}`).then((res) => res.data);
}

export function fetchUserWorkSummary(userId) {
  return axios.get(`users/workSummary/${userId}`).then((res) => res.data);
}

export function fetchUserReliability(userId) {
  return axios.get(`users/reliability/${userId}`).then((res) => res.data);
}

export function markProfileEdited() {
  return axios.patch("users/profileEdited").then((res) => res.data);
}

export function submitEngineerProfile() {
  return axios.get(`users/engineer/submitProfile`).then((res) => res.data);
}

export function adminUpdateUserProfile({ userId, data }) {
  return axios.patch(`users/admin/${userId}`, data).then((res) => res.data);
}
